<template>
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.58798 8.73994L2.65852 15.4418C2.41876 15.9903 2.35678 16.6045 3.41926 16.6045H4.74033V21.4856C4.74033 22.2498 5.35985 22.8693 6.12407 22.8693H8.93156L10.2031 27.2018H20.1396V21.5978C21.83 19.2772 24.8017 15.0302 24.8017 10.4369C24.8017 7.98808 23.1535 1.63021 15.1478 1.53602C8.7432 1.46068 6.106 6.30724 5.58798 8.73994Z"
            fill="#5625CC" />
        <path
            d="M18.988 8.58258V14.32H17.5828V8.58258H18.988ZM17.4873 7.08193C17.4873 6.87336 17.558 6.70014 17.6994 6.56227C17.8443 6.4244 18.0388 6.35547 18.2827 6.35547C18.5266 6.35547 18.7193 6.4244 18.8607 6.56227C19.0056 6.70014 19.0781 6.87336 19.0781 7.08193C19.0781 7.28696 19.0056 7.45842 18.8607 7.59629C18.7193 7.73415 18.5266 7.80309 18.2827 7.80309C18.0388 7.80309 17.8443 7.73415 17.6994 7.59629C17.558 7.45842 17.4873 7.28696 17.4873 7.08193Z"
            fill="white" />
        <path
            d="M13.4253 7.77149L11.2247 14.3202H9.68164L12.5663 6.59961H13.5526L13.4253 7.77149ZM15.2653 14.3202L13.0541 7.77149L12.9216 6.59961H13.9131L16.8137 14.3202H15.2653ZM15.1646 11.4515V12.6022H11.0232V11.4515H15.1646Z"
            fill="white" />
    </svg>
</template>
<script>
export default {
    name: "AiAsistant",
};
</script>
<style lang="scss">
</style>
